// Generated by Scripts/Generate-Permissions.py. Do not edit.
export const permissionNames = {
  ReadDemands: "demand:record:read",
  CreateDemands: "demand:record:create",
  UpdateDemands: "demand:record:update",
  DeleteDemands: "demand:record:delete",
  ReadReports: "demand:report:read",
  ReadGovernance: "demand:governance:read",
  ReadProjects: "project:portfolio:read",
  ManageSettings: "platform:settings:manage",
  AdminSettings: "platform:configuration:read",
  AdministrationManage: "platform:administration:manage",
  AccessDemandManagement: "demand:portfolio:read",
  AccessDemandDashboard: "demand:summary:read",
  ReadMobileLibrary: "catalog:library:read",
  ReadMobileProducts: "catalog:product:read",
  ReadMobileCategories: "catalog:category:read",
  ReadAllArticles: "catalog:article:read",
  ReadMobileProductFinance: "catalog:finance:read",
  ReadProductSearch: "catalog:search:read",
  ReadMobileCollections: "catalog:collection:read:own",
  CreateMobileCollections: "catalog:collection:create:own",
  UpdateMobileCollections: "catalog:collection:update:own",
  DeleteMobileCollections: "catalog:collection:delete:own",
  CreateCollectionMembership: "catalog:collection_membership:create:own",
  DeleteCollectionMembership: "catalog:collection_membership:delete:own",
  GeneratePDFs: "product:pdf_job:read",
  CatalogSearchSyncRead: "catalog:search_sync:read",
  CatalogSearchSyncRun: "catalog:search_sync:run",
  CampaignConceptRead: "campaign:concept:read",
  CampaignConceptCreate: "campaign:concept:create",
  CampaignConceptUpdate: "campaign:concept:update",
  CampaignConceptDelete: "campaign:concept:delete",
  CampaignRecordRead: "campaign:record:read",
  CampaignRecordCreate: "campaign:record:create",
  CampaignRecordUpdate: "campaign:record:update",
  CampaignRecordDelete: "campaign:record:delete",
  CampaignBrandRead: "campaign:brand:read",
  CampaignBrandCreate: "campaign:brand:create",
  CampaignBrandUpdate: "campaign:brand:update",
  CampaignBrandDelete: "campaign:brand:delete",
  CampaignBriefGenerate: "campaign:brief:generate",
  CampaignCreativeGenerate: "campaign:creative:generate",
  CampaignStyleRead: "campaign:style:read",
  CampaignStyleCreate: "campaign:style:create",
  CampaignStyleUpdate: "campaign:style:update",
  CampaignStyleDelete: "campaign:style:delete",
  CampaignStyleExtract: "campaign:style:extract",
  CampaignImageGenerate: "campaign:image:generate",
  CampaignTargetProfileRead: "campaign:target_profile:read",
  CampaignTargetProfileCreate: "campaign:target_profile:create",
  CampaignTargetProfileUpdate: "campaign:target_profile:update",
  CampaignTargetProfileDelete: "campaign:target_profile:delete",
  HubspotFormRead: "hubspot:form:read",
  HubspotFormBackfill: "hubspot:form:backfill",
  HubspotFormRefresh: "hubspot:form:refresh",
  HubspotBackfillRead: "hubspot:backfill:read",
  HubspotBackfillCreate: "hubspot:backfill:create",
  HubspotBackfillCancel: "hubspot:backfill:cancel",
  HubspotEmailMetricsRead: "hubspot:email_metrics:read",
  HubspotEmailMetricsUpdate: "hubspot:email_metrics:update",
  HubspotEmailMetricsReset: "hubspot:email_metrics:reset",
  HubspotEmailMetricsBackfillCreate: "hubspot:email_metrics_backfill:create",
  ProductRecordRead: "product:record:read",
  ProductAssistantGenerate: "product:assistant:generate",
  ProductPdfJobCreate: "product:pdf_job:create",
  ProductPdfJobUpdate: "product:pdf_job:update",
  ProductPdfJobDelete: "product:pdf_job:delete",
  ProductComparisonRead: "product:comparison:read",
  ProductComparisonCompare: "product:comparison:compare",
  ProductComparisonAnalyze: "product:comparison:analyze",
  ProductComparisonExport: "product:comparison:export",
  ProductCatalogTemplateRead: "product:catalog_template:read",
  ProductCatalogTemplateUpload: "product:catalog_template:upload",
  ProductCatalogTemplateUpdate: "product:catalog_template:update",
  ProductCatalogTemplateDelete: "product:catalog_template:delete",
  ProductBusinessRuleRead: "product:business_rule:read",
  ProductBusinessRuleCreate: "product:business_rule:create",
  ProductBusinessRuleUpdate: "product:business_rule:update",
  ProductBusinessRuleDelete: "product:business_rule:delete",
  ProductValidationRunRead: "product:validation_run:read",
  ProductValidationRunCreate: "product:validation_run:create",
  ProductValidationRunCancel: "product:validation_run:cancel",
  ProductValidationRunDelete: "product:validation_run:delete",
  ProductValidationWorkflowRead: "product:validation_workflow:read",
  ProductValidationWorkflowUpdate: "product:validation_workflow:update",
  ProductValidationWorkflowCancel: "product:validation_workflow:cancel",
  FeedbackRecordCreate: "feedback:record:create",
  FeedbackRecordReadOwn: "feedback:record:read:own",
  FeedbackRecordReadAssigned: "feedback:record:read:assigned",
  FeedbackRecordReadTeam: "feedback:record:read:team",
  FeedbackRecordReadAny: "feedback:record:read:any",
  FeedbackRecordUpdateOwn: "feedback:record:update:own",
  FeedbackRecordUpdateAssigned: "feedback:record:update:assigned",
  FeedbackRecordUpdateTeam: "feedback:record:update:team",
  FeedbackRecordTriage: "feedback:record:triage",
  FeedbackRecordAssign: "feedback:record:assign",
  FeedbackRecordUpdateStatus: "feedback:record:update_status",
  FeedbackCommentCreatePublic: "feedback:comment:create:public",
  FeedbackCommentCreateInternal: "feedback:comment:create:internal",
  FeedbackAttachmentUpload: "feedback:attachment:upload",
  FeedbackAttachmentRead: "feedback:attachment:read",
  FeedbackAttachmentDelete: "feedback:attachment:delete",
  FeedbackReportReadTeam: "feedback:report:read:team",
  FeedbackReportReadAny: "feedback:report:read:any",
  FeedbackReportExport: "feedback:report:export",
  FeedbackAuditRead: "feedback:audit:read",
  FeedbackSettingsManage: "feedback:settings:manage",
  NotificationDeviceCreateOwn: "notification:device:create:own",
  NotificationDeviceUpdateOwn: "notification:device:update:own",
  NotificationDeviceDeleteOwn: "notification:device:delete:own",
  NotificationInboxItemReadOwn: "notification:inbox_item:read:own",
  NotificationInboxItemUpdateOwn: "notification:inbox_item:update:own",
  NotificationPreferenceReadOwn: "notification:preference:read:own",
  NotificationPreferenceUpdateOwn: "notification:preference:update:own",
  NotificationCampaignRead: "notification:campaign:read",
  NotificationCampaignDelete: "notification:campaign:delete",
  NotificationCampaignCreate: "notification:campaign:create",
  NotificationCampaignSend: "notification:campaign:send",
  NotificationAudienceRead: "notification:audience:read",
  NotificationAudienceEstimate: "notification:audience:estimate",
  NotificationTargetProfileRead: "notification:target_profile:read",
  NotificationTargetProfileUpdate: "notification:target_profile:update",
  NotificationRecipientRead: "notification:recipient:read",
  ProductFieldRestrictionRead: "product:field_restriction:read",
  ProductFieldRestrictionUpdate: "product:field_restriction:update",
  ProductInriverRoleAssignmentUpdate: "product:inriver_role_assignment:update",
  ProductInriverRoleAssignmentRead: "product:inriver_role_assignment:read",
} as const;
export const legacyPermissionAliases: Record<string, readonly string[]> = {
  "demand:record:read": [
    "read:demands"
  ],
  "demand:record:create": [
    "write:demands",
    "create:demands"
  ],
  "demand:record:update": [
    "update:demands",
    "manage:demands"
  ],
  "demand:record:delete": [
    "delete:demands",
    "manage:demands"
  ],
  "demand:report:read": [
    "read:reports"
  ],
  "demand:governance:read": [
    "read:governance"
  ],
  "project:portfolio:read": [
    "read:projects"
  ],
  "platform:settings:manage": [
    "manage:settings"
  ],
  "platform:configuration:read": [
    "admin:settings"
  ],
  "platform:administration:manage": [
    "admin:all",
    "manage:all"
  ],
  "demand:portfolio:read": [
    "access:demand-management"
  ],
  "demand:summary:read": [
    "access:demand-dashboard"
  ],
  "catalog:library:read": [
    "read:mobile-library"
  ],
  "catalog:product:read": [
    "read:mobile-products"
  ],
  "catalog:category:read": [
    "read:mobile-categories"
  ],
  "catalog:article:read": [
    "read:all-articles"
  ],
  "catalog:finance:read": [
    "read:mobile-product-finance"
  ],
  "catalog:search:read": [
    "read:product-search"
  ],
  "catalog:collection:read:own": [
    "read:mobile-collections"
  ],
  "catalog:collection:create:own": [
    "create:mobile-collections"
  ],
  "catalog:collection:update:own": [
    "update:mobile-collections"
  ],
  "catalog:collection:delete:own": [
    "update:mobile-collections"
  ],
  "catalog:collection_membership:create:own": [
    "write:mobile-collection-memberships"
  ],
  "catalog:collection_membership:delete:own": [
    "write:mobile-collection-memberships"
  ],
  "product:pdf_job:read": [
    "generate:pdfs"
  ],
  "catalog:search_sync:read": [
    "manage:product-search-sync"
  ],
  "catalog:search_sync:run": [
    "manage:product-search-sync"
  ],
  "campaign:concept:read": [
    "access:concepts"
  ],
  "campaign:concept:create": [
    "manage:concepts"
  ],
  "campaign:concept:update": [
    "manage:concepts"
  ],
  "campaign:concept:delete": [
    "manage:concepts"
  ],
  "campaign:record:read": [
    "access:campaign-management"
  ],
  "campaign:record:create": [
    "add:campaigns"
  ],
  "campaign:record:update": [
    "add:campaigns"
  ],
  "campaign:record:delete": [
    "add:campaigns",
    "delete:campaign"
  ],
  "campaign:brand:read": [
    "access:campaign-management"
  ],
  "campaign:brand:create": [
    "add:campaigns"
  ],
  "campaign:brand:update": [
    "add:campaigns"
  ],
  "campaign:brand:delete": [
    "add:campaigns"
  ],
  "campaign:brief:generate": [
    "access:campaign-management"
  ],
  "campaign:creative:generate": [
    "access:campaign-management"
  ],
  "campaign:style:read": [
    "access:campaign-management"
  ],
  "campaign:style:create": [
    "access:campaign-management"
  ],
  "campaign:style:update": [
    "access:campaign-management"
  ],
  "campaign:style:delete": [
    "access:campaign-management"
  ],
  "campaign:style:extract": [
    "access:campaign-management"
  ],
  "campaign:image:generate": [
    "access:campaign-management"
  ],
  "campaign:target_profile:read": [
    "access:campaign-management"
  ],
  "campaign:target_profile:create": [
    "access:campaign-management"
  ],
  "campaign:target_profile:update": [
    "access:campaign-management"
  ],
  "campaign:target_profile:delete": [
    "access:campaign-management"
  ],
  "hubspot:form:read": [
    "manage:hubspot",
    "access:campaign-management",
    "add:campaigns"
  ],
  "hubspot:form:backfill": [
    "manage:hubspot"
  ],
  "hubspot:form:refresh": [
    "manage:hubspot"
  ],
  "hubspot:backfill:read": [
    "manage:hubspot"
  ],
  "hubspot:backfill:create": [
    "manage:hubspot"
  ],
  "hubspot:backfill:cancel": [
    "manage:hubspot"
  ],
  "hubspot:email_metrics:read": [
    "manage:hubspot"
  ],
  "hubspot:email_metrics:update": [
    "manage:hubspot"
  ],
  "hubspot:email_metrics:reset": [
    "manage:hubspot"
  ],
  "hubspot:email_metrics_backfill:create": [
    "manage:hubspot"
  ],
  "product:record:read": [
    "product:pdfs"
  ],
  "product:assistant:generate": [
    "product:pdfs"
  ],
  "product:pdf_job:create": [
    "product:pdfs"
  ],
  "product:pdf_job:update": [
    "product:pdfs"
  ],
  "product:pdf_job:delete": [
    "product:pdfs"
  ],
  "product:comparison:read": [
    "product:pdfs"
  ],
  "product:comparison:compare": [
    "product:pdfs"
  ],
  "product:comparison:analyze": [
    "product:pdfs"
  ],
  "product:comparison:export": [
    "product:pdfs"
  ],
  "product:catalog_template:read": [
    "product:pdfs"
  ],
  "product:catalog_template:upload": [
    "product:pdfs"
  ],
  "product:catalog_template:update": [
    "product:pdfs"
  ],
  "product:catalog_template:delete": [
    "product:pdfs"
  ],
  "product:business_rule:read": [
    "product:pdfs"
  ],
  "product:business_rule:create": [
    "product:pdfs"
  ],
  "product:business_rule:update": [
    "product:pdfs"
  ],
  "product:business_rule:delete": [
    "product:pdfs"
  ],
  "product:validation_run:read": [
    "product:pdfs"
  ],
  "product:validation_run:create": [
    "product:pdfs"
  ],
  "product:validation_run:cancel": [
    "product:pdfs"
  ],
  "product:validation_run:delete": [
    "product:pdfs"
  ],
  "product:validation_workflow:read": [
    "product:pdfs"
  ],
  "product:validation_workflow:update": [
    "product:pdfs"
  ],
  "product:validation_workflow:cancel": [
    "product:pdfs"
  ],
  "feedback:record:create": [
    "feedback:create"
  ],
  "feedback:record:read:own": [
    "feedback:read:own"
  ],
  "feedback:record:read:assigned": [
    "feedback:read:assigned"
  ],
  "feedback:record:read:team": [
    "feedback:read:team"
  ],
  "feedback:record:read:any": [
    "feedback:read:any"
  ],
  "feedback:record:update:own": [
    "feedback:update:own"
  ],
  "feedback:record:update:assigned": [
    "feedback:update:assigned"
  ],
  "feedback:record:update:team": [
    "feedback:update:team"
  ],
  "feedback:record:triage": [
    "feedback:triage"
  ],
  "feedback:record:assign": [
    "feedback:assign"
  ],
  "feedback:record:update_status": [
    "feedback:status:update"
  ],
  "feedback:comment:create:public": [
    "feedback:comment:public"
  ],
  "feedback:comment:create:internal": [
    "feedback:comment:internal"
  ],
  "feedback:attachment:upload": [
    "feedback:attachment:upload"
  ],
  "feedback:attachment:read": [
    "feedback:attachment:read"
  ],
  "feedback:attachment:delete": [
    "feedback:attachment:delete"
  ],
  "feedback:report:read:team": [
    "feedback:report:read:team"
  ],
  "feedback:report:read:any": [
    "feedback:report:read:any"
  ],
  "feedback:report:export": [
    "feedback:export"
  ],
  "feedback:audit:read": [
    "feedback:audit:read"
  ],
  "feedback:settings:manage": [
    "feedback:settings:manage"
  ],
  "notification:device:create:own": [],
  "notification:device:update:own": [],
  "notification:device:delete:own": [],
  "notification:inbox_item:read:own": [],
  "notification:inbox_item:update:own": [],
  "notification:preference:read:own": [],
  "notification:preference:update:own": [],
  "notification:campaign:read": [],
  "notification:campaign:delete": [],
  "notification:campaign:create": [],
  "notification:campaign:send": [],
  "notification:audience:read": [],
  "notification:audience:estimate": [],
  "notification:target_profile:read": [],
  "notification:target_profile:update": [],
  "notification:recipient:read": [],
  "product:field_restriction:read": [],
  "product:field_restriction:update": [],
  "product:inriver_role_assignment:update": [],
  "product:inriver_role_assignment:read": []
};
export function grantsPermission(grants: readonly string[], permission: string): boolean {
  return grants.includes(permission) || (legacyPermissionAliases[permission] ?? []).some(alias => grants.includes(alias));
}
export function canonicalScopes(scopes: string): string {
  return [...new Set(scopes.split(/\s+/).flatMap(scope => {
    const replacements = Object.keys(legacyPermissionAliases).filter(name => legacyPermissionAliases[name].includes(scope));
    return replacements.length ? replacements : [scope];
  }))].join(" ");
}
